import {createSlice} from '@reduxjs/toolkit';
import {tablePaginate} from '../../helper/jsons/tablePaginate';

const initialState = {
    dataRows:   [],
    totalCount: '',
    filter: tablePaginate,
    showSearchBox: false,
    loading: false,
    againHandlerWarningCount: true,
    getAgain: true,
};

export const TableRedux = createSlice({
    name: 'dataRows',
    initialState,
    reducers: {
        getDataRows: (state, action) => {
            state.dataRows = action.payload;
        },

        getTotalCount: (state, action) => {
            state.totalCount = action.payload;
        },
        getFilter: (state, action) => {

            state.filter = {...action.payload};
        },

        showSearchBoxHandler: (state) => {
            state.showSearchBox = !state.showSearchBox;
        },
        isLoading: (state, action) => {
            state.loading = action.payload;
        },
        getAgainHandler: (state) => {
            state.getAgain = !state.getAgain;
        },
        getAgainHandlerWarningCount: (state) => {
            state.againHandlerWarningCount = !state.againHandlerWarningCount;
        },

    },
});

export const {
    getAgainHandler,
    getAgainHandlerWarningCount,
    isLoading,
    getDataRows,
    getFilter,
    getTotalCount,
    showSearchBoxHandler,
} = TableRedux.actions;

export default TableRedux.reducer;

